// extracted by mini-css-extract-plugin
export default {"list":"MuseumStoryList_list__ttfaZ"};